export default function RogersTestimonialsSection() {
  return (
    <section id="testimonials" className="bg-[#1A365D] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Traveler Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">What Rogers &amp; NWA Residents Say</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { name: "Marcus R.", location: "Walmart Global Sourcing, Rogers", text: "I got a last-minute assignment to Shenzhen and my passport was expired. Fast Passport Center had a new one in my hands in 36 hours. Literally saved my career moment. Use them if you're Walmart." },
            { name: "Jennifer H.", location: "Pinnacle Hills, Rogers", text: "We planned a family European river cruise and needed passports for all four kids. They walked us through every step and all four passports arrived in one week. Brilliant service." },
            { name: "Tom B.", location: "Pea Ridge, AR", text: "My wife and I planned an anniversary trip to Italy. When we realized our passports had expired, I panicked. Fast Passport Center had them renewed in 6 days. Everything went perfectly." },
          ].map((t, i) => (
            <div key={i} className="bg-white/10 backdrop-blur rounded-lg p-6 border border-white/10">
              <div className="flex items-center gap-1 mb-4">{[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-[#F6C344] text-sm"></i>)}</div>
              <p className="text-white/90 text-sm leading-relaxed mb-4">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#F6C344] flex items-center justify-center text-[#1A365D] font-bold text-sm">{t.name[0]}</div>
                <div><p className="text-white font-semibold text-sm">{t.name}</p><p className="text-white/60 text-xs">{t.location}</p></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}